import { render, staticRenderFns } from "./XMSPay.vue?vue&type=template&id=7d8c3004"
import script from "./XMSPay.vue?vue&type=script&lang=js"
export * from "./XMSPay.vue?vue&type=script&lang=js"
import style0 from "./XMSPay.vue?vue&type=style&index=0&id=7d8c3004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports